import React from "react";
import style from "./dressingAppearance.module.scss";
import editIcon from "../../../../static/images/edit-icon-blue.png";
import { signedLockedAccess } from "../../../../utils";

export const DressingAppearanceViewMode = ({ resp, assessmentDetails, hideButtons, onEdit, isReadOnly }) => (
  <div className={`row ${style.col_spec}`}>
    <label className="col-5">Dressing Appearance: </label>
    <span className={`col-6 p-0 ${style.first_letter_capital}`}>{resp?.dressingAppearance}</span>
    {signedLockedAccess(assessmentDetails?.assessmentStage) && hideButtons && (
      <button className={style.tab_edit} onClick={onEdit} disabled={isReadOnly}>
        <img src={editIcon} alt="icon" className={style.e_icon_space} />
        Edit
      </button>
    )}
  </div>
);
